<template>
	<section class="room-number-list">
		<input
			v-if="tag === 'label' && !editIsActive"
			name="rooms"
			hidden
			type="checkbox"
			:disabled="room.isAssigned"
			:id="labelFor"
			v-model="room.isSelected"
			v-on:change="roomSelected(room, index)">
		<div class="edit-container" v-if="editIsActive">
			<input
				type="text"
				v-model="room.codeRoom"
				maxlength="4"
				v-on:click="clickEdit"
				class="input-to-edit">
			<v-icon v-on:click="onRoomRemove(room)" class="delete-icon">cancel</v-icon>
		</div>
		<label
			:for="labelFor"
			class="room-number"
			@click="goToLink(link)"
			:class="{ 'disabled': room.isAssigned, 'active': room.isSelected }"
			v-if="!editIsActive">
			<span>{{ room.codeRoom }}</span>
		</label>
	</section>
</template>

<script>
function goToLink(link) {
	if (this.tag !== 'label') {
		this.$router.push(link);
	}
}

function roomSelected(room) {
	if (this.tag === 'label') {
		this.$emit('on-room-selected', room);
	}
}

function onRoomRemove(room) {
	this.$emit('on-room-removed', room);
}

function clickEdit() {
	this.$emit('on-click-edit', true);
}

export default {
	methods: {
		clickEdit,
		goToLink,
		onRoomRemove,
		roomSelected,
	},
	name: 'room-number-list',
	props: {
		index: {
			type: [String, Number],
		},
		room: {
			type: Object,
			required: true,
		},
		labelFor: {
			type: [String, Number],
		},
		tag: {
			type: String,
			default: 'a',
		},
		link: {
			type: String,
		},
		editIsActive: {
			type: Boolean,
			default: false,
		},
	},
};
</script>


<style lang="scss" scoped>
.room-number-list {
	display: inline-flex;

	a,
	a:focus,
	label,
	label:focus,
	.input-to-edit {
		align-items: center;
		background-color: #ffffff;
		border: 2px solid transparent;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		color: map-get($colors, default-button-color);
		cursor: pointer;
		display: inline-flex;
		height: 40px;
		justify-content: center;
		margin-bottom: 13px;
		margin-right: 13px;
		outline: none;
		text-decoration: none;
		width: 85px;

		&:hover {
			border-color: map-get($colors, default-skyblue);
		}
	}

	.input-to-edit {
		border: 0px;
		box-shadow: none;
		outline: solid map-get($colors, default-skyblue);
		text-align: center;

		&:hover {
			border: 0px;
		}
	}

	input:checked ~ label {
		background-color: map-get($colors, default-skyblue);
		color: #ffffff;
	}

	label.disabled,
	input:disabled,
	input:disabled ~ label {
		background-color: map-get($colors, disabled-habs);
		border: 0px;
		box-shadow: inset 0px 2px 4px 0px rgba(0, 0, 0, .16);
		cursor: default;
		pointer-events: none;
	}

	.edit-container {
		position: relative;
		.delete-icon {
			color: map-get($colors, default-red);
			cursor: pointer;
			font-size: 18px;
			position: absolute;
			right: 8px;
			top: -5px;
		}
	}
}
</style>




// WEBPACK FOOTER //
// RoomNumberList.vue?186240f3